<template>
    <Spinner v-if="isLoading" />

	<div class="grid nested-grid">
		<div class="col-12">
			<div class="card fluid cardheader">
				<div class="col-12">
					<h5 class="stationsHeader">{{ translated('energysites').toUpperCase() }} <span v-if="viewedCompanName"> - {{ viewedCompanName }}</span></h5>
				</div>												
			</div>

            <DataTable stateStorage="local" stateKey="dt-state-locations-session" :value="energysites" class="p-datatable-sm" removableSort :resizableColumns="true" columnResizeMode="fit" showGridlines dataKey="id" 
            v-model:filters="filters1" filterDisplay="menu" responsiveLayout="scroll" :rowHover="true"
            :globalFilterFields="['Name','Street','City']"
            :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,20,50]" :currentPageReportTemplate="tableShowingData()">
                    <template #header>
                        <div class="flex justify-content-between">
                            <div class="holderaddenergysite">
                                <Button v-if="!isMinisterstvo" :label="this.translated('newsitebutton')" icon="pi pi-plus" class="p-button" @click="newEnergySite"  />	
                            </div>
                            
                            <span class="p-input-icon-right ">
                                <i class="pi pi-search" />
                                <InputText v-model="filters1['global'].value" :placeholder="this.translated('keywordsearch')" />
                            </span>
                        </div>
                    </template>        
                    <template #empty>
                        {{ translated('norecordsfound') }}
                    </template>
                    <template #loading>
                        {{ translated('loadingdata') }}
                    </template>    
                    
                <Column :header="translated('companyname')" field="Name" :sortable="true"></Column>
                <Column :header="translated('street')" field="Street" :sortable="true"></Column>            
                <Column :header="translated('housenumber')" field="Housenumber"></Column>
                <Column :header="translated('tablecity')" field="City" :sortable="true"></Column>
                <Column headerStyle="width: 3em" bodyStyle="text-align: center">
                    <template #body="slotProps">
                        <!-- <p class="exporttest">ID: {{ slotProps.data.Id }}</p> -->
                        <router-link :to="{ name: 'EditEnergySite', params: { id: slotProps.data.Id, viewedCompanName: this.viewedCompanName, viewcompanyid: this.viewcompanyid }}"> 
                            <Button icon="pi pi-pencil" class="p-button-raised p-button-rounded p-button-secondary" />
                            <!-- <span class="testbutt">Nekaj</span> -->
                        </router-link>
                        <!-- <Button icon="pi pi-power-off" class="p-button-raised p-button-rounded p-button-warning" @click="onLogout" /> -->
                    </template>
                </Column>            
            </DataTable>
        </div>
    </div>
</template>

<script>
import {FilterMatchMode,FilterOperator} from 'primevue/api';
import createHttp from "@/services/http";
import router from "@/router/index";
import { computed } from "vue"
import store from "@/store";
import Spinner from "@/components/Spinner.vue"
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  components: { Spinner },
  props: ['viewcompanyid','viewedCompanName'],
  data() {
    return {
      isLoading : true,
      energysites : null,
      filters1: null,
      translated: computed(() => store.getters.getTranslate)     
    }
  },
  /*
  watch: {
    $route(to, from) {
        console.log('beforeRouteUpdate');
        console.log(to);
        console.log(from);        
    }
  },   
  */
  created() {
      this.initFilters1();
  },  
  async mounted() {

    // console.log('ID GORAZD:' + this.viewcompanyid, this.viewedCompanName, typeof this.viewcompanyid, typeof this.viewedCompanName);
      // tu preverim ali sem mogoče dobil parameter ID in če sem ga potem moram ta ID tudi uporabit !!! 
    let paramString = "";
    if(typeof this.viewcompanyid != 'undefined' && typeof this.viewcompanyid === 'string' && this.viewcompanyid.length > 0){
        // console.log('PARAM ID: ' + this.viewcompanyid, this.viewcompanyid.length);
        paramString = "?paramcompanyid=" + this.viewcompanyid;
    }        

    const http = createHttp(true); 
    const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetEnergySites" + paramString);
    //console.log('prejel nazaj:')
    //console.log(result)

    if(result.status==200){
        this.energysites = result.data
    }

    this.isLoading = false;
/*
    fetch('https://localhost:44378/Infrastructure/GetEnergySites')
      .then(res => res.json())
      .then(data => this.energysites = data)
      .then(() => console.log(this.energysites))
      .catch(err => console.log(err.message))
*/

   //console.log(this.energysites)
  },
computed: {
    isMinisterstvo() {
        return (this.$store.getters.isInRole("MAdmin") || this.$store.getters.isInRole("MUser"));
        //return (this.$store.getters.getRole=="MAdmin" || this.$store.getters.getRole=="MUser");
        //return true;
    }
},      
  methods: {
      tableShowingData() {
          // "Showing {first} to {last} of {totalRecords}"
          return this.translated('tableshowing') + " {first} " + this.translated('tableto') + " {last} " + this.translated('showingof') + " {totalRecords}";
      },
      newEnergySite() {
        router.push({ name: 'EditEnergySite', params: { id: '00000000-0000-0000-0000-000000000000' } })
      },
      clearFilter1() {
          this.initFilters1();
      },
      initFilters1() {
          this.filters1 = {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
          }
      }
  }  
}
</script>


<style scoped>
/* .p-jc-end {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
}

.flex {
    display: -webkit-box!important;
    display: -ms-flexbox!important;
    display: flex!important;
} */



</style>

